import type { ServiceCategory } from "@/types";

export function catalogCategoryOptions(
  categories: ServiceCategory[],
  selectedCategoryId: string,
) {
  return categories.filter(
    (category) =>
      category.active || category.id.toString() === selectedCategoryId,
  );
}
